module.exports = __webpack_public_path__ + "img/bg_left.10cefac0.png";